import React from "react";
import { faqs } from "../mock";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="reveal text-center">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Frågor & svar</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">Vanliga frågor</h2>
          <p className="mt-4 text-slate-600 text-lg">Här hittar du svaren på det vi oftast får frågor om.</p>
        </div>
        <Accordion type="single" collapsible className="reveal mt-10 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="rounded-2xl bg-slate-50 ring-1 ring-slate-100 px-6 border-none">
              <AccordionTrigger className="text-left text-[16px] font-bold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-[15px] pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
